module.exports = __webpack_public_path__ + "img/play-icon.263b4428.png";